var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.566 3.887-2.453-2.453a1.478 1.478 0 0 0-2.092 0l-9.63 9.63a.527.527 0 0 0-.139.247l-1.236 5.035a.528.528 0 0 0 .638.638l5.035-1.236a.527.527 0 0 0 .247-.14l9.63-9.63a1.478 1.478 0 0 0 0-2.091zM2.25 15.75l.05-.205.155.155-.205.05zm1.403-.344-1.059-1.06.46-1.875 2.475 2.474-1.876.46zm2.911-.918-3.052-3.052 7.881-7.882 3.053 3.053-7.882 7.881zm9.257-9.257-.61.61-3.052-3.052.61-.61a.423.423 0 0 1 .599 0l2.453 2.453a.423.423 0 0 1 0 .6z",
    fill: "#000",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 0.5,
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.6222cda1f0d35bdb3c195334ebae0b76.svg";
export { ForwardRef as ReactComponent };